import React, { FC, useState } from 'react';

import classes from 'classnames';
import { prop } from 'ramda';

import RenderInDomNode from 'components/Pages/Admin/Page/common/RenderInStuff';
import BaseInput from 'components/shared/FormAdapters/FormBase/Input';
import baseStyles from 'components/shared/FormAdapters/FormDefault/Input/index.module.css';
import Icon from 'components/shared/Icon';
import Visibility from 'components/shared/Icon/icons/Visibility';
import PasswordRequirementLayer from 'components/shared/PasswordRequirementPopup';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import PasswordRequirementContent from '../../../PasswordRequirementPopup/PasswordRequirementContent';
import styles from './index.module.css';
import { IPasswordInputProps } from './types';

const PasswordInput: FC<IPasswordInputProps> = ({
  size,
  isError,
  disabled,
  withIcon,
  withPasswordRequirementsTip,
  value,
  fieldTipsRef,
  tipOffset,
  ...props
}) => {
  const { isTabletOrMobile } = useMediaBreakpoints();
  const [showPassword, setShowPassword] = useState(false);

  const inputType = showPassword ? 'text' : 'password';
  const passwordInputContainerClasses = classes(
    baseStyles.inputContainer,
    styles.inputContainer,
    size && prop(`inputContainer-${size}`, baseStyles),
    disabled && prop('inputContainer-disabled', baseStyles),
    isError && prop('inputContainer-isError', baseStyles),
  );
  const inputClasses = classes(baseStyles.input, withIcon && prop('input', styles));

  const iconClasses = classes(styles.icon, showPassword && prop('iconActive', styles));

  const handleToggleIcon = () => setShowPassword(!showPassword);

  return (
    <>
      <PasswordRequirementLayer
        show={withPasswordRequirementsTip && !isTabletOrMobile}
        values={value}
        tipOffset={tipOffset}
      >
        <div className={passwordInputContainerClasses}>
          <BaseInput {...props} type={inputType} className={inputClasses} disabled={disabled} />
          {withIcon && (
            //@ts-ignore
            <button tabIndex="-1" type="button" onClick={handleToggleIcon} className={styles.iconBtn}>
              <Icon component={Visibility} className={iconClasses} />
            </button>
          )}
        </div>
      </PasswordRequirementLayer>
      {withPasswordRequirementsTip && isTabletOrMobile && (
        //@ts-ignore
        <RenderInDomNode refNode={fieldTipsRef}>
          <div className={classes(styles.position)}>
            <PasswordRequirementContent values={value} />
          </div>
        </RenderInDomNode>
      )}
    </>
  );
};

export default PasswordInput;
